import { CSSProperties, FC, useCallback, useMemo, useState } from 'react';
import { useIntersectionObserver } from '../../utils/intersectionObserver/useIntersectionObserver';

interface TeamLogoProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    onErrorBehaviour: 'hide' | 'remove';
}

export const TeamLogo: FC<TeamLogoProps> = (props) => {
    const { onErrorBehaviour, src, ...restProps } = props;
    const { isVisible, setRef } = useIntersectionObserver();
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [hasSrcBeenSet, setHasSrcBeenSet] = useState(false);

    const handleImageLoad = useCallback(() => {
        setIsLoaded(true);
        setHasSrcBeenSet(true);
    }, []);

    const handleError = useCallback(() => {
        setHasError(true);
    }, []);

    const style = useMemo((): CSSProperties => {
        if (hasError) {
            return onErrorBehaviour === 'hide' ? { visibility: 'hidden' } : { display: 'none' };
        }
        if (!isLoaded) {
            return { visibility: 'hidden' };
        }
        return { visibility: 'visible' };
    }, [hasError, isLoaded, onErrorBehaviour]);

    return (
        <img
            ref={setRef}
            src={hasSrcBeenSet ? src : isVisible ? src : undefined}
            onError={handleError}
            onLoad={handleImageLoad}
            style={style}
            {...restProps}
        />
    );
};
